import Vue from "vue";
import Router from "vue-router";
import NotFound from "./views/pages/NotFound.vue";
import SetToken from "./views/pages/SetToken.vue";
// WAP
import NavBarMobileBottom from "./layout/WapV2/NavBarMobileBottom.vue";
import MainNavBarWap from "./layout/Wap/MainNavBar.vue";
import AppFooterWap from "./layout/Wap/AppFooter.vue";
// import BookedWap from "./views/pages/wap/booked/index.vue";
import WapLoginOtp from "./views/pages/wap/otp/Otp.vue";
import Vietin from "./views/pages/wap/Vietin.vue";
import VietinShop from "./views/pages/wap/VietinShop.vue";
import Navigate from "./views/pages/wap/Navigate.vue";
import NavigateSTB from "./views/pages/wap/NavigateSTB.vue";
import STBShop from "./views/pages/wap/STBShop.vue";
import STBHio from "./views/pages/wap/STBHio.vue";
import RedirectHandde from "./views/pages/wap/RedirectHandde.vue";
import Message from "./views/pages/wap/Message.vue";

// WAPV2
import AppFooterWapV2 from "./layout/WapV2/AppFooter.vue";
import HomePageWapV2 from "@/views/pages/wapV2/HomePage.vue";
import DetailBooked from "@/views/pages/wapV2/booking/detailBooked.vue";
import VerifyOtp from "@/views/pages/wapV2/otp/OtpVerify";
import PaymentMethod from "@/views/pages/wapV2/payment/Method.vue";
import QrPaymentMethod from "@/views/pages/wapV2/payment/QRPayment.vue";
import EpayMethod from "@/views/pages/wapV2/payment/EpayPayment.vue";
import PointPaymentMethod from "@/views/pages/wapV2/payment/PointPayment.vue";
import RedirectUrlPayBidv from "@/views/pages/wapV2/payment/PaymentBidv.vue";
import PaymentPolicy from "./views/pages/wapV2/policy/Payment.vue";
import PaymentDelivery from "./views/pages/wapV2/policy/Delivery.vue";
import PaymentInfoSecurity from "./views/pages/wapV2/policy/PaymentInfoSecurity.vue";
import Cancellation from "./views/pages/wapV2/policy/Cancellation.vue";
import TermsTransaction from "./views/pages/wapV2/policy/TermsTransaction.vue";
import UserInfoSecurity from "./views/pages/wapV2/policy/UserInfoSecurity.vue";
import ComplaintResolutionMechanism from "./views/pages/wapV2/policy/ComplaintResolutionMechanism.vue";
import NavigateBidv from "./views/pages/wapV2/Navigate.vue";
import TermsAndConditionsV2 from "./views/pages/wapV2/TermsAndConditions.vue";
import AddMemberWapV2 from "@/views/pages/wapV2/addMember/index.vue";
import HistoryWapV2 from "@/views/pages/wapV2/history/index.vue";
import DetailHistoryBookedWapV2 from "@/views/pages/wapV2/history/DetailBooked.vue";
import InsuranceCertificate from "@/views/pages/wapV2/insurance";
import RulesInsurance from "@/views/pages/wapV2/insurance/rules.vue";
import HistoryTransactionWallet from "@/views/pages/wapV2/wallet/History.vue";
import AddPointWallet from "@/views/pages/wapV2/wallet/AddPoint.vue";
import PaymentMethodWallet from "@/views/pages/wapV2/wallet/Method.vue";
import QRPaymentWallet from "@/views/pages/wapV2/wallet/QRPayment.vue";
import LinkOtherService from "@/views/pages/wapV2/iframe/Index.vue";
import FindBillByCourseWapV2 from "@/views/pages/wapV2/history/FindByCourse.vue";
import ListTeetime from "@/views/pages/wapV2/teetime";
import BookingNow from "./views/pages/wapV2/teetime/create.vue";
import PriceBooking from "./views/pages/wapV2/facility/Price.vue";
import PriceVietinbankBooking from "./views/pages/wapV2/facility/PriceVietinbank.vue";

import News from "./views/pages/wapV2/news/List.vue";
import ReviewFacility from "./views/pages/wapV2/facility/CarouselFacility/ReviewAll.vue";
import DetailFacility from "./views/pages/wapV2/facility/CarouselFacility/Detail.vue";
import DetailNews from "./views/pages/wapV2/news/components/Detail.vue";
import AlePayPayment from "./views/pages/wapV2/payment/AlePayPayment.vue";
// UN USE NOW

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/404",
      name: "404",
      components: {
        default: NotFound
      }
    },
    {
      path: "/",
      name: "homepage",
      redirect: "/wap"
    },

    {
      path: "/bussiness",
      name: "homepage",
      components: {
        default: HomePageWapV2,
        header: "",
        footer: AppFooterWapV2,
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/jinpro",
      name: "homepage",
      components: {
        default: HomePageWapV2,
        header: "",
        footer: AppFooterWapV2,
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/evga",
      name: "homepage",
      components: {
        default: HomePageWapV2,
        header: "",
        footer: AppFooterWapV2,
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/set-token",
      name: "setToken",
      components: {
        default: SetToken,
        header: MainNavBarWap,
        footer: AppFooterWap
      }
    },
    // ******************************************************************
    // *                              WAPV2                               *
    // ******************************************************************
    {
      path: "/wap",
      name: "homepage",
      components: {
        default: HomePageWapV2,
        header: "",
        footer: AppFooterWapV2,
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/web",
      name: "homepage",
      components: {
        default: HomePageWapV2,
        header: "",
        footer: AppFooterWapV2
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/wap/booking/detail-tee-time/:id",
      name: "detail-tee-time",
      components: {
        default: DetailBooked,
        header: "",
        footer: ""
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/wap/add-member",
      name: "wap-add-member-wap",
      components: {
        default: AddMemberWapV2,
        header: "",
        footer: ""
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/wap/term-and-condition",
      name: "wap-term-and-condition",
      components: {
        default: TermsAndConditionsV2,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/vietin",
      name: "vietin",
      components: {
        default: Vietin
      }
    },
    {
      path: "/vietin-shop",
      name: "vietin-shop",
      components: {
        default: VietinShop
      }
    },
    {
      path: "/wap/login-otp",
      name: "wap-login-otp",
      components: {
        default: WapLoginOtp
      }
    },
    {
      path: "/wap/detail-history-booked/:id",
      name: "wap-detail-history-booked",
      components: {
        default: DetailHistoryBookedWapV2,
        header: "",
        footer: ""
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },

    {
      path: "/wap/history",
      name: "wap-history",
      components: {
        default: HistoryWapV2,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/wap/verify-otp",
      name: "wap-verify-otp",
      components: {
        default: VerifyOtp,
        header: "",
        footer: ""
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },

    {
      path: "/navigate",
      name: "wap-verify-otp",
      components: {
        default: Navigate,
        header: "",
        footer: ""
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/wap/insurance-certificate",
      name: "wap-insurance-certificate",
      components: {
        default: InsuranceCertificate,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      },
      meta: { transition: "slide-right" }
    },
    {
      path: "/wap/rules-insurance",
      name: "wap-rules-insurance",
      components: {
        default: RulesInsurance,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      },
      meta: { transition: "slide-right" }
    },
    {
      path: "/wap/payment-method",
      name: "wap-payment-method",
      components: {
        default: PaymentMethod,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/wap/qr-payment",
      name: "wap-qr-payment",
      components: {
        default: QrPaymentMethod,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/wap/epay-payment",
      name: "wap-epay-payment",
      components: {
        default: EpayMethod,
        header: "",
        footer: ""
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/wap/alepay-payment",
      name: "wap-alepay-payment",
      components: {
        default: AlePayPayment,
        header: "",
        footer: ""
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/wap/wallet/history-transaction",
      name: "wallet-history-transaction",
      components: {
        default: HistoryTransactionWallet,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/wap/wallet/add-point",
      name: "wallet-add-point",
      components: {
        default: AddPointWallet,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/wap/wallet/payment-method",
      name: "wap-wallet-payment-method",
      components: {
        default: PaymentMethodWallet,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/wap/wallet/qr-payment",
      name: "wap-wallet-qr-payment",
      components: {
        default: QRPaymentWallet,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/navigate-stb",
      name: "navigate-stb",
      components: {
        default: NavigateSTB
      }
    },
    {
      path: "/navigate-bidv",
      name: "navigate-bidv",
      components: {
        default: NavigateBidv
      }
    },
    {
      path: "/stb-shop",
      name: "stb-shop",
      components: {
        default: STBShop
      }
    },
    {
      path: "/redirect-handde",
      name: "redirect-handde",
      components: {
        default: RedirectHandde
      }
    },
    {
      path: "/stb-hio",
      name: "stb-hio",
      components: {
        default: STBHio
      }
    },
    {
      path: "/wap/point-payment",
      name: "wap-point-payment",
      components: {
        default: PointPaymentMethod,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      }
    },
    {
      path: "/wap/payment-method/payment-bidv",
      name: "wap-payment-bidv",
      components: {
        default: RedirectUrlPayBidv,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      }
    },
    {
      path: "/wap/redirect-other-service",
      name: "redirect-other-service",
      components: {
        default: LinkOtherService,
        header: "",
        footer: ""
      }
    },
    {
      path: "/message",
      name: "message",
      components: {
        default: Message,
        header: "",
        footer: ""
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },

    {
      path: "/policy/payment",
      name: "policy-payment",
      components: {
        default: PaymentPolicy,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/policy/delivery",
      name: "policy-delivery",
      components: {
        default: PaymentDelivery,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/policy/payment-info-security",
      name: "policy-payment-info-security",
      components: {
        default: PaymentInfoSecurity,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/policy/cancellation",
      name: "policy-cancellation",
      components: {
        default: Cancellation,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/policy/terms-transaction",
      name: "policy-terms-transaction",
      components: {
        default: TermsTransaction,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/policy/user-info-security",
      name: "policy-user-info-security",
      components: {
        default: UserInfoSecurity,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/policy/complaint-resolution-mechanism",
      name: "policy-complaint-resolution-mechanism",
      components: {
        default: ComplaintResolutionMechanism,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/wap/find-bill-by-course",
      name: "wap-find-bill-by-course",
      components: {
        default: FindBillByCourseWapV2,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/teetime",
      name: "list-teetime",
      components: {
        default: ListTeetime,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },

    {
      path: "/booking-now",
      name: "booking-now",
      components: {
        default: BookingNow,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/bang-gia",
      name: "bang-gia",
      components: {
        default: PriceBooking,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/baogia",
      name: "baogia",
      components: {
        default: PriceVietinbankBooking,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/san-noi-bat",
      name: "san-noi-bat",
      components: {
        default: ReviewFacility,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/san/chi-tiet/:id",
      name: "review-facility-detail",
      components: {
        default: DetailFacility,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/tin-tuc",
      name: "news",
      components: {
        default: News,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/tin-tuc/chi-tiet/:id",
      name: "detail-news",
      components: {
        default: DetailNews,
        header: "",
        footer: "",
        "mobile-navbar-bottom": NavBarMobileBottom
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    }

    // ******************************************************************
    // *                         UN USE NOW                             *
    // ******************************************************************
  ],
  mode: "history",
  // routes: [{ path: "/:pathMatch(.*)", component: NotFound }],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
